import { Text, View } from "react-native";
import { EmploymentWarningModal } from "./EmploymentWarningModal";
import { ChangeStatusEnum } from "../screens/EmploymentEditScreen/types";

type ModalConfig = {
  title: string;
  text: string;
  requirements?: string[];
  additionalText?: string;
};

const modalConfigs = {
  [ChangeStatusEnum.RETIRED_MEMBER]: {
    title: "Retired Member",
    text: "By continuing you are confirming that you meet the PGA of America constitutional requirements for retired status.",
    requirements: [
      "Does the sum of your age and the number of years you have maintained active PGA Membership status equal or exceed 65?",
    ],
  },
  [ChangeStatusEnum.RESERVE_MEMBER]: {
    title: "Reserve Member",
    text: "If you are requesting to transfer to Reserve membership status, please verify that you are NOT eligible for classification as an Active or Life Member.",
    additionalText: "If both conditions are met, you meet the requirements to move into Reserve membership status.",
  },
  [ChangeStatusEnum.LIFE_MEMBER_RETIRED]: {
    title: "Life Member Retired",
    text: "You've selected to move into Life Member Retired Membership status. Please review the following requirements and confirm you believe you have met the requirements.",
    requirements: [
      "You have a minimum of 20 years in an Active Classification (whether continuous or not)",
      "You do not otherwise, based on your current employment status, qualify for an Active Classification.",
    ],
  },
  [ChangeStatusEnum.LIFE_MEMBER_ACTIVE]: {
    title: "Life Member Active",
    text: "You've selected to move into Life Member Active Membership status. Please review the following requirements and confirm you believe you have met the requirements.",
    requirements: [
      "You have a minimum of 20 years in an Active Classification (whether continuous or not)",
      "You completed the entrance education as defined in ARTICLE IV, Section 1. Election Requirements.",
      "You do not otherwise, based on your current employment status, qualify for an Active Classification.",
    ],
  },
  [ChangeStatusEnum.LIFE_MEMBER_CENTURY]: {
    title: "Life Member Century",
    text: "You've selected to move into Life Member Century Membership status. Please review the following requirements and confirm you believe you have met the requirements.",
    requirements: [
      "You are a current life member",
      "You are at least 75 years of age",
      "You have served at least 25 years of active membership",
    ],
  },
};

const BulletPoints = ({ textArray }: { textArray: string[] }) => {
  return textArray.map((text, index) => (
    <View key={index} className="flex-row mb-6">
      <Text className="text-regular-normal font-400 text-ink-dark mr-2">•</Text>
      <Text className="text-regular-normal font-400 text-ink-dark">{text}</Text>
    </View>
  ));
};

const InactiveStatusModals = ({
  showStatusChangeWarningModal,
  setShowStatusChangeWarningModal,
  onContinue,
}: {
  showStatusChangeWarningModal: string;
  setShowStatusChangeWarningModal: (status: ChangeStatusEnum | "") => void;
  onContinue: () => void;
}) => {
  const renderTextComponent = (config: ModalConfig) => {
    if (config.requirements) {
      return (
        <View className="mb-4">
          <Text className="text-regular-normal font-400 text-ink-dark mb-2">Requirements:</Text>
          <View className="p-4">
            <BulletPoints textArray={config.requirements} />
          </View>
        </View>
      );
    }
    if (config.additionalText) {
      return <Text className="text-regular-normal font-400 text-ink-dark mb-6 mt-2">{config.additionalText}</Text>;
    }
    return null;
  };

  return (
    <>
      {Object.entries(modalConfigs).map(([status, config]) => (
        <EmploymentWarningModal
          key={status}
          visible={showStatusChangeWarningModal === status}
          onDismiss={() => setShowStatusChangeWarningModal("")}
          title={config.title}
          text={config.text}
          TextComponent={() => renderTextComponent(config)}
          onContinue={() => {
            onContinue();
            setShowStatusChangeWarningModal("");
          }}
        />
      ))}
    </>
  );
};

export default InactiveStatusModals;
